import * as React from 'react'
import { Base_Component } from './Base.ui.Component'
import { Rout_back } from '../Rout/Rout'
import { UI_RoundedButton } from '../UI/UI.RoundedButton'
import { Translations } from '../../../shared/i18n/Translations'
import type { IconName } from '../../../shared/webcomponents/helpers/icons'

interface Props {
    location: {
        query: {
            entity?: 'report'
        }
    }
}

export class Base_PageNotFound extends Base_Component<Props, {}> {
    public tryRender() {
        const { entity } = this.props.location.query

        const config = getNotFoundConfig(entity)

        const icon = config.icon || 'broken-logo'
        const title = config.title || Translations.t('app:Base.PageNotFound.title')
        const message = config.message || Translations.t('app:Base.PageNotFound.message')

        return (
            <div className="Base_PageNotFound">
                <div className="Base_PageNotFound-content">
                    <zaptic-icon icon-name={icon}></zaptic-icon>
                    <div className="Base_PageNotFound-title">{title}</div>
                    <div className="Base_PageNotFound-message">{message}</div>
                    <div className="Base_PageNotFound-button">
                        <UI_RoundedButton
                            buttonText={Translations.t('app:Base.PageNotFound.buttonLabel')}
                            style="primary"
                            onClick={Rout_back}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

function getNotFoundConfig(entity: string): { icon?: IconName; title?: string; message?: string } {
    switch (entity) {
        case 'report':
            return {
                icon: 'search-no-result',
                title: Translations.t('app:Rpts.NotFoundPage.title'),
                message: Translations.t('app:Rpts.NotFoundPage.message'),
            }
    }

    return {
        icon: null,
        title: null,
        message: null,
    }
}
